<template>
    <div class="scc-container">
        <footer class="scc-app-footer">
            <div class="scc-app-footer__main-container">
                <div class="scc-app-footer__main-container-left">
                    <p class="scc-app-footer__title h6">{{ title }}</p>
                    <div v-if="links && links.length > 0" class="scc-app-footer__links">
                        <div v-for="(link, i) in links" :key="i" class="scc-app-footer__link">
                            <div class="scc-app-footer__link-icon"></div>
                            <p class="scc-app-footer__link-text">
                                <SccLink :to="link.link">
                                    {{ link.name }}
                                </SccLink>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="scc-app-footer__main-container-right">
                    <div class="scc-app-footer__logos">
                        <template v-for="(logo, i) in logos">
                            <SccLink v-if="logo.link" :key="i" :to="logo.link">
                                <img :src="logo.image" alt="Logo" />
                            </SccLink>
                            <img v-else :key="i" :src="logo.image" alt="Logo" />
                        </template>
                    </div>
                    <p class="scc-app-footer__text kwf-note">{{ text }}</p>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import './app-footer.scss';
import SccLink from '../global/SccLink';

export default {
    name: 'AppFooter',
    components: { SccLink },
    __editor: {
        fields: {
            links: {
                widget: 'array',
                values: {
                    flat: false,
                    fields: {
                        name: {
                            widget: 'text',
                        },
                        link: {
                            widget: 'text',
                        },
                    },
                },
            },
            logos: {
                widget: 'array',
                values: {
                    flat: false,
                    fields: {
                        image: {
                            widget: 'media',
                        },
                        link: {
                            widget: 'text',
                        },
                    },
                },
            },
        },
    },
    props: {
        title: {
            type: String,
            default: 'Over de KWF Loterij',
        },
        links: {
            type: Array,
            default() {
                return [
                    {
                        name: 'Veelgestelde vragen',
                        link: 'veelgestelde-vragen',
                    },
                    {
                        name: 'Deelnemersreglement',
                        link: 'deelnemersreglement',
                    },
                ];
            },
        },
        text: {
            type: String,
            default: '',
        },
        logos: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
